const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3333/';

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
    this.name = 'ApiError';
  }
}

export const getApiUrl = () => API_URL;

async function parseErrorMessage(response: Response): Promise<string> {
  try {
    const body = await response.json();
    if (typeof body.message === 'string') return body.message;
    if (Array.isArray(body.message)) return body.message.join(', ');
    if (typeof body.error === 'string') return body.error;

    const cause = body.cause;
    if (cause && typeof cause === 'object') {
      const causeMessage = (cause as { message?: string }).message;
      if (causeMessage) return causeMessage;
      const causeData = (cause as { response?: { data?: { message?: string } } }).response?.data;
      if (causeData?.message) return causeData.message;
    }
  } catch {
    // ignore
  }
  return response.statusText || 'Erro inesperado';
}

export async function apiRequest<T>(
  path: string,
  options: RequestInit & { token?: string } = {},
): Promise<T> {
  const { token, headers, ...rest } = options;

  const response = await fetch(`${API_URL}${path.replace(/^\//, '')}`, {
    ...rest,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
  });

  if (!response.ok) {
    const message = await parseErrorMessage(response);
    throw new ApiError(message, response.status);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return response.json() as Promise<T>;
}

export const onlyDigits = (value: string) => value.replace(/\D/g, '');
